export default __webpack_public_path__ + "static/media/Comp 2_00028.6127e41c.png";